import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";

const inputSchema = z.object({ url: z.string().trim().min(3).max(300) });

/** Public (unauthenticated) instant website check. Rate-limited and cached server-side. */
export const runWebsiteCheck = createServerFn({ method: "POST" })
  .inputValidator((data) => inputSchema.parse(data))
  .handler(async ({ data }) => {
    const [{ checkWebsite }, { getRequestHeader }] = await Promise.all([
      import("./website-check.server"),
      import("@tanstack/react-start/server"),
    ]);
    const ip =
      getRequestHeader("cf-connecting-ip") ??
      getRequestHeader("x-forwarded-for")?.split(",")[0]?.trim() ??
      "unknown";
    return checkWebsite(data.url, ip);
  });
